export default {"src":"/_next/static/media/vericapNameLogo.e0beb970.svg","height":29,"width":102,"blurWidth":0,"blurHeight":0};